import React from 'react'
import {useTranslation, Trans} from 'react-i18next'

import {Box} from '@mui/material'
import {PGButton, PGTypography, PGModal} from '@progynyglobal/pg-ui-library'
import {makeStyles} from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  modal: {
    '& .MuiDialog-paper': {
      maxWidth: 540,
      width: '100%',
    },
  },
}))

type EmotionalWellBeingDisclaimerModalProps = {
  open: boolean
  onClose: () => void
  onAcknowledge: () => void
  loading?: boolean
}

const EmotionalWellBeingDisclaimerModal: React.FC<
  EmotionalWellBeingDisclaimerModalProps
> = ({open, onClose, onAcknowledge, loading = false}) => {
  const {t} = useTranslation()
  const {classes} = useStyles()

  return (
    <PGModal
      open={open}
      showCloseButton={true}
      onClose={onClose}
      title={t(
        'consultations_program_emotional_well_being_disclaimer_modal_about_this'
      )}
      className={classes.modal}
    >
      <Box>
        <Box sx={{marginBottom: 3}}>
          <PGTypography variant='body'>
            <Trans i18nKey='consultations_program_emotional_well_being_disclaimer_modal_this_progr' />
          </PGTypography>
        </Box>
        <Box display='flex' gap={1} justifyContent='center'>
          <PGButton
            variant='contained'
            label={t(
              'consultations_program_emotional_well_being_disclaimer_modal_i_understa'
            )}
            onClick={onAcknowledge}
            loading={loading}
          />
        </Box>
      </Box>
    </PGModal>
  )
}

export default EmotionalWellBeingDisclaimerModal
